import React, { useEffect, useState  } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../config/apiConfig';

const Home = () => {
    const [exploreCategories, setExploreCategories] = useState([]);
    const [latestCategories, setLatestCategories] = useState([]);
    const [aboutSection, setAboutSection] = useState({});
    const [testimonials, setTestimonials] = useState([]);
    const [trendingCategories, setTrendingCategories] = useState([]);
    const [experienceCustom, setExperienceCustom] = useState(null);

  useEffect(() => {
    let swiperInstance;

    const initializeSwiper = () => {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
      }

      swiperInstance = new Swiper(".rbt-banner-activation", {
        loop: true,
        autoplay: false,
        navigation: {
          nextEl: ".rbt-swiper-arrow.rbt-arrow-right",
          prevEl: ".rbt-swiper-arrow.rbt-arrow-left"
        },
        effect: "fade"
      });
    };

    const loadSliders = (sliders) => {
      const sliderWrapper = document.getElementById("slider-wrapper");

      sliderWrapper.innerHTML = `
        <div class="swiper rbt-banner-activation rbt-slider-animation rbt-arrow-between" style="height: 100vh;">
            <div class="swiper-wrapper" id="slider-container"></div>

            <div class="rbt-swiper-arrow rbt-arrow-left">
                <div class="custom-overfolow">
                    <i class="rbt-icon feather-arrow-left"></i>
                    <i class="rbt-icon-top feather-arrow-left"></i>
                </div>
            </div>

            <div class="rbt-swiper-arrow rbt-arrow-right">
                <div class="custom-overfolow">
                    <i class="rbt-icon feather-arrow-right"></i>
                    <i class="rbt-icon-top feather-arrow-right"></i>
                </div>
            </div>
        </div>
        <div class="swiper rbt-swiper-thumb rbtmySwiperThumb"></div>
      `;

      const sliderContainer = document.getElementById("slider-container");

      sliders.forEach(slide => {
        const imageUrl = slide.imageUrl || "assets/images/guyshirt1.jpg";
        const title = slide.ctA_Title || "New Arrivals";
        const content = slide.content || "Lorem ipsum dolor sit amet consectetur adipisicing elit.";
        const buttonText = slide.buttonText || "Shop new arrivals";
        const buttonLink = slide.buttonLink || "#";

        const slideHTML = `
          <div class="swiper-slide">
              <div class="rbt-banner-area rbt-banner-6 variation-03 bg_image bg_image--17" 
                  style="background-image: url(${imageUrl}); background-size: cover;"
                  data-gradient-overlay="5">
                  <div class="wrapper w-100" style="margin-bottom: 200px;">
                      <div class="container">
                          <div class="row align-items-center">
                              <div class="col-lg-12">
                                  <div class="inner text-center">
                                      <div class="section-title">
                                          <span class="subtitle bg-white-opacity d-inline-block">
                                              ${title}
                                          </span>
                                      </div>
                                      <h1 class="title w-700">${title}<br />
                                          <strong class="color-white">
                                              <p class="color-whit" style="font-weight: 400;">
                                                  ${content}
                                              </p>
                                          </strong>
                                      </h1>
                                      <div class="button-group mt--30">
                                          <a class="rbt-btn btn-gradient rbt-marquee-btn" href="${buttonLink}">
                                              <span data-text="${buttonText}">
                                                  ${buttonText}
                                              </span>
                                          </a>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        `;

        sliderContainer.innerHTML += slideHTML;
      });

      setTimeout(initializeSwiper, 100); // Ensure DOM is ready
    };

    const loadHomePage = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/admin/homepage/api/data`);
        const homepageData = await res.json();

        if (homepageData?.sliders) loadSliders(homepageData.sliders);
        if (homepageData?.exploreCategories) setExploreCategories(homepageData.exploreCategories);
        if (homepageData?.latestCategories) setLatestCategories(homepageData.latestCategories);
        if (homepageData?.aboutSection) setAboutSection(homepageData.aboutSection);
        if (homepageData?.trendingCategories) setTrendingCategories(homepageData.trendingCategories);
        if (homepageData?.experienceCustom) setExperienceCustom(homepageData.experienceCustom);

        

      } catch (error) {
        console.error("Error fetching homepage data:", error);
      }
    };

    loadHomePage();
  }, []);

  useEffect(() => {
    const fetchTestimonials = async () => {
        try {
        const res = await fetch(`${API_BASE_URL}/api/testimonials?page=Home`);
        const data = await res.json();
        setTestimonials(data);
        } catch (error) {
        console.error("Failed to fetch testimonials:", error);
        }
    };
    fetchTestimonials();
  }, []);

  useEffect(() => {
    const styleId = 'latest-image-fix';
    if (document.getElementById(styleId)) return;
  
    const style = document.createElement('style');
    style.id = styleId;
    style.innerHTML = `
  .rbt-team-modal-thumb .rbt-team-thumbnail {
    width: 100%;
  }

  .rbt-team-modal-thumb .rbt-team-thumbnail .thumb {
    width: 100%;
    height: 320px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .rbt-team-modal-thumb .rbt-team-thumbnail .thumb img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
    display: block;
  }
`;
    document.head.appendChild(style);
  }, []);

  useEffect(() => {
    if (trendingCategories.length === 0) return;

    new Swiper(".team-slide-activation-4", {
      loop: true,
      slidesPerView: 3,
      spaceBetween: 30,
      navigation: {
        nextEl: ".rbt-swiper-arrow.rbt-arrow-right",
        prevEl: ".rbt-swiper-arrow.rbt-arrow-left",
      },
      pagination: {
        el: ".rbt-swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: { slidesPerView: 2 },
        1024: { slidesPerView: 3 },
      },
    });
  }, [trendingCategories]);

  

  return (
    <>
      <Header />
      <main className="rbt-main-wrapper">

        <div className="rbt-slider-main-wrapper position-relative" id="slider-wrapper">
            {/* <!-- Slider will be dynamically inserted here via JavaScript --> */}
        </div>

        <div class="rbt-advance-tab-area bg-gradient-2 rbt-section-gapTop rbt-section-gapBottom">
          <div class="container">
            <div class="row mb--40">
              <div class="col-lg-12">
                <div class="section-title text-center">
                  <h2 class="title">Explore</h2>
                </div>
              </div>
            </div>

            <div class="row g-5">
              <div class="col-lg-10 offset-lg-1">
                <div class="tab-content advance-tab-content-style-2"></div>
              </div>
            </div>

            <div class="row g-5 mt--40">
              {exploreCategories.map((item, index) => (
                <div class="col-lg-6" key={index}>
                  <Link to={item.link || "#"}>
                    <div class="rbt-category-gallery">
                      <div class="thumbnail">
                        <img src={item.imageUrl} alt="Gallery Images" />
                        <div class="rbt-bg-overlay"></div>
                        <div class="hover-content">
                          <h3 class="title">{item.categoryName}</h3>
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
        
        <div className="rbt-team-area rbt-section-gap" style={{ background: 'linear-gradient(to right,white, #e5e5e5)' }}>
            <div className="container">
                <div className="row mb--60 g-5 align-items-end">
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="section-title text-start">
                    <h2 className="title">Latest</h2>
                    </div>
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                    <div className="read-more-btn text-start text-md-end">
                    <a className="rbt-btn hover-icon-reverse radius-round btn-white" href="#">
                        <div className="icon-reverse-wrapper">
                        <span className="btn-text">All</span>
                        <span className="btn-icon"><i className="feather-arrow-right"></i></span>
                        <span className="btn-icon"><i className="feather-arrow-right"></i></span>
                        </div>
                    </a>
                    </div>
                </div>
                </div>

                <div className="row g-5" id="latest-row">
                {latestCategories.map((item, index) => (
                    <div className="col-lg-3 col-md-6 col-sm-6 col-12" key={index}>
                    <div className="rbt-team-modal-thumb nav nav-tabs">
                        <a className="rbt-team-thumbnail" href={item.link || "#"}>
                        <div className="thumb">
                            <img src={item.imageUrl} alt="Testimonial Images" />
                            <div className="hover-text">{item.categoryName}</div>
                        </div>
                        </a>
                    </div>
                    </div>
                ))}
                </div>
            </div>
        </div>



        

        <div className="about-style-2 rbt-section-gapBottom"> 
            <div className="container">
                <div className="row">
                <div className="col-lg-10 offset-lg-1">
                    <div className="row row--0 about-wrapper align-items-center" style={{ marginTop: '100px' }}>
                    <div className="col-lg-6">
                        <div className="thumbnail">
                        <img src={aboutSection.imageUrl || "assets/images/about.jpg"} alt="About Images" />
                        </div>
                    </div>
                    <div className="col-lg-6 mt_md--30 mt_sm--30">
                        <div className="content">
                        <div className="inner">
                            <h4 className="title">
                            <span className="">About</span> Us
                            </h4>
                            <ul className="contact-address">
                            <p>{aboutSection.aboutText || "Loading about content..."}</p>
                            </ul>
                            <div className="signature-image mt--20">
                            <div className="slider-btn">
                                <a className="rbt-btn btn-gradient hover-icon-reverse" href="/about">
                                <span className="icon-reverse-wrapper">
                                    <span className="btn-text">Know More</span>
                                    <span className="btn-icon"><i className="feather-arrow-right"></i></span>
                                    <span className="btn-icon"><i className="feather-arrow-right"></i></span>
                                </span>
                                </a>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="top-circle-shape position-bottom-right"></div>
                    </div>
                </div>
                </div>
            </div>
        </div>


     {/* <!-- Start Banner Area  --> */}
     <div class="rbt-banner-area rbt-banner-8 variation-03 rbt-section-gapBottom" id="home">
        
        <div class="banner-overlay-section" style={{marginTop: '0'}}>
            <h2 class="text-center">
                Trending Categories
            </h2>
            <div class="container">
                <div class="row row--15">
                    <div class="col-lg-12">
                        <div class="swiper team-slide-activation-4 rbt-arrow-between rbt-dot-bottom-center">
                            <div className="swiper-wrapper">
  {trendingCategories.map((item) => (
    <div className="swiper-slide" key={item.id}>
      <div className="team team-style--bottom variation-2">
        <div className="thumbnail">
          <a href={item.link}>
            <img src={item.imageUrl} alt={item.categoryName} />
          </a>
        </div>
        <div className="content">
          <div className="inner">
            <h4 className="title">
              <a href={item.link}>{item.categoryName}</a>
            </h4>
          </div>
          <div className="icon-right">
            <a href={item.link}><i className="feather-arrow-right"></i></a>
          </div>
        </div>
      </div>
    </div>
  ))}
</div>


                            <div class="rbt-swiper-arrow rbt-arrow-left">
                                <div class="custom-overfolow">
                                    <i class="rbt-icon feather-arrow-left"></i>
                                    <i class="rbt-icon-top feather-arrow-left"></i>
                                </div>
                            </div>

                            <div class="rbt-swiper-arrow rbt-arrow-right">
                                <div class="custom-overfolow">
                                    <i class="rbt-icon feather-arrow-right"></i>
                                    <i class="rbt-icon-top feather-arrow-right"></i>
                                </div>
                            </div>


                            <div class="rbt-swiper-pagination"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- End Banner Area  --> */}

     {/* <!-- Start Service Area --> */}
    {experienceCustom && (
  <div className="rbt-service-area bg-gradient-2 rbt-section-gapTop rbt-section-gapBottom">
    <div className="container">
      <div className="row mb--60">
        <div className="col-lg-12">
          <div className="section-title text-center experience-div">
            <h2 className="title">{experienceCustom.sectionTitle}</h2>

            {experienceCustom.mainButtonText && experienceCustom.mainButtonLink && (
              <a
                id="create-btn"
                className="rbt-btn btn-gradient hover-icon-reverse"
                href={experienceCustom.mainButtonLink}
              >
                <span className="icon-reverse-wrapper">
                  <span className="btn-text">{experienceCustom.mainButtonText}</span>
                  <span className="btn-icon"><i className="feather-arrow-right"></i></span>
                  <span className="btn-icon"><i className="feather-arrow-right"></i></span>
                </span>
              </a>
            )}
          </div>
        </div>
      </div>

      <div className="col-12">
        <div className="row">
          {experienceCustom.cards?.map((card) => (
            <div className="col-lg-6 col-12" key={card.id}>
              <div className="rbt-service rbt-service-2 rbt-hover-02 bg-no-shadow">
                <div className="inner">
                  <div className="content">
                    <h4 className="title"><a href={card.buttonLink}>{card.title}</a></h4>
                    <p>{card.description}</p>
                    <a className="transparent-button" href={card.buttonLink}>
                      {card.buttonText}
                      <i>
                        <svg width="17" height="12" xmlns="http://www.w3.org/2000/svg">
                          <g stroke="#27374D" fill="none" fillRule="evenodd">
                            <path d="M10.614 0l5.629 5.629-5.63 5.629" />
                            <path strokeLinecap="square" d="M.663 5.572h14.594" />
                          </g>
                        </svg>
                      </i>
                    </a>
                  </div>
                  <div className="thumbnail">
                    <img src={card.imageUrl} alt={card.title} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
)}


    {/* <!-- End Service Area --> */}

    <div className="rbt-testimonial-area bg-color-white rbt-section-gap overflow-hidden">
  <div className="container">
    <div className="row align-items-center row--30">
      <div className="col-lg-6">
        <div className="rbt-testimonial-content tab-content" id="myTabContent">
          {testimonials.map((t, index) => (
            <div
              className={`tab-pane fade ${index === 0 ? "active show" : ""}`}
              id={`testimonial-tab${index + 1}`}
              role="tabpanel"
              aria-labelledby={`testimonial-tab${index + 1}-tab`}
              key={t.testimonialID}
            >
              <div className="inner">
                {t.rating > 0 && (
                  <div className="rating mb--30">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <a key={i} href="#"><i className="fa fa-star"></i></a>
                    ))}
                  </div>
                )}
                <p>{t.message}</p>
              </div>
              <div className="author-info">
                <h6>
                  <span>{t.name}</span> - {t.location || "Customer"}
                </h6>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="col-lg-6 mt_md--30 mt_sm--30">
        <ul className="testimonial-thumb-wrapper nav nav-tabs" id="myTab" role="tablist">
          {testimonials.map((t, index) => (
            <li key={t.testimonialID}>
              <a
                className={index === 0 ? "active" : ""}
                id={`testimonial-tab${index + 1}-tab`}
                data-bs-toggle="tab"
                data-bs-target={`#testimonial-tab${index + 1}`}
                role="tab"
                aria-controls={`testimonial-tab${index + 1}`}
                aria-selected={index === 0 ? "true" : "false"}
              >
                <div className="testimonial-thumbnai">
                  <div className="thumb">
                    <img
                      src={t.imageUrl || "/assets/images/profile1.jpg"}
                      alt="Testimonial"
                      style={{ objectFit: "cover", height: "100%", width: "100%", borderRadius: "6px" }}
                    />
                  </div>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </div>
</div>


       
    <Footer />
    

    </main>
    {/* <!-- End Page Wrapper Area --> */}
    <div class="rbt-progress-parent">
        <svg class="rbt-back-circle svg-inner" width="100%" height="100%" viewBox="-1 -1 102 102">
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
        </svg>
    </div>
    </>
  );
};

export default Home;
